import {Component, Input} from '@angular/core';

import {CapaActivityStatus} from '../audit.model';

@Component({
  selector: 'iaud-audit-capa-status',
  templateUrl: './audit-capa-status.component.html',
  styleUrls: ['./audit-capa-status.component.scss'],
})
export class AuditCapaStatusComponent {
  @Input() status: string;

  get statusClass(): string {
    switch (this.status) {
      case CapaActivityStatus.DRAFT:
        return 'draft';
      case CapaActivityStatus.COMPLETED:
        return 'completed';
      case CapaActivityStatus.IN_PROGRESS:
        return 'in-progress';
      case CapaActivityStatus.OVERDUE:
        return 'overdue';
      default:
        return null;
    }
  }
}
